import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_46229_1367)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9 18C9 18.7956 9.31607 19.5587 9.87868 20.1213C10.4413 20.6839 11.2044 21 12 21C12.7956 21 13.5587 20.6839 14.1213 20.1213C14.6839 19.5587 15 18.7956 15 18",
				stroke: "#614395",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.25 2.25C18.6983 3.17411 19.873 4.46888 20.6522 6",
				stroke: "#614395",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.3479 6C4.12712 4.46888 5.3018 3.17411 6.75009 2.25",
				stroke: "#614395",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.24988 10.5C5.24988 8.70979 5.96104 6.9929 7.22691 5.72703C8.49278 4.46116 10.2097 3.75 11.9999 3.75C13.7901 3.75 15.507 4.46116 16.7729 5.72703C18.0387 6.9929 18.7499 8.70979 18.7499 10.5C18.7499 13.8581 19.528 15.8063 20.1468 16.875C20.2125 16.9888 20.2471 17.1179 20.2472 17.2493C20.2474 17.3808 20.2129 17.5099 20.1474 17.6239C20.0819 17.7378 19.9876 17.8325 19.874 17.8985C19.7603 17.9645 19.6313 17.9995 19.4999 18H4.49988C4.36861 17.9992 4.23985 17.964 4.12646 17.8978C4.01308 17.8317 3.91904 17.7369 3.85375 17.6231C3.78845 17.5092 3.7542 17.3801 3.7544 17.2489C3.75459 17.1176 3.78925 16.9887 3.85488 16.875C4.4727 15.8063 5.24988 13.8572 5.24988 10.5Z",
				stroke: "#614395",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_46229_1367",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBell;
